import React, { Fragment } from 'react'
import { createPortal } from 'react-dom'
import styled from '@emotion/styled'
import { color, spacer } from 'stylist'
import { BlueInfo } from 'components/Icon'
import ReactTooltip from 'react-tooltip'

const StyledTooltip = styled(ReactTooltip)`
  z-index: ${({ zIndex }) => (zIndex ? zIndex : '1001')};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '300px')};

  &.type-dark {
    background-color: ${color('slate')};

    &.place-top::after {
      border-top-color: ${color('slate')};
    }
    &.place-bottom::after {
      border-bottom-color: ${color('slate')};
    }
    &.place-left::after {
      border-left-color: ${color('slate')};
    }
    &.place-right::after {
      border-right-color: ${color('slate')};
    }
  }

  &.show {
    opacity: 1;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
  }

  a {
    font-weight: 500;
    text-decoration: underline;
  }
`

const Tooltip = ({ id, contents, children, enabled = true, ...props }) => (
  <Fragment>
    {React.Children.map(children, child =>
      React.cloneElement(child, {
        'data-tip': true,
        'data-for': id
      })
    )}
    {enabled &&
      createPortal(
        <StyledTooltip id={id} {...props}>
          {contents}
        </StyledTooltip>,
        document.getElementById('tooltip-root')
      )}
  </Fragment>
)

Tooltip.defaultProps = {
  effect: 'solid'
}

const Info = styled(BlueInfo)`
  margin-left: ${spacer(2)};
`

export const InfoTooltip = ({ id, contents }) => (
  <Tooltip
    id={id}
    effect="solid"
    contents={contents}
    maxWidth={450}
    delayHide={100}
    html
    clickable
  >
    <Info size="xs" />
  </Tooltip>
)

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip.js